import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useApiClient } from "../useApiClient";
import type { components } from "../schema";

import { TRADES_QUERY_KEY } from "./useTrades";

type Body = components["schemas"]["BulkTagTradesBody"];
type Response = components["schemas"]["BulkTagTradesResponse"];

export function useBulkReplaceTradeTags() {
  const client = useApiClient();
  const queryClient = useQueryClient();
  return useMutation<Response, Error, Body>({
    mutationFn: async (body) => {
      const { data, error } = await client.POST("/api/trades/bulk-tag/replace", { body });
      if (error !== undefined) {
        throw new Error("Failed to replace tags on selected trades");
      }
      return data;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: TRADES_QUERY_KEY });
    },
  });
}
